import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Welcome } from "./pages/Welcome/Welcome";
import { ReadingAssessment } from "./pages/Assessment/ReadingAssessment/ReadingAssessment";
import { ListeningAssessment } from "./pages/Assessment/ListeningAssessment/ListeningAssessment";
import { AssessmentsManagerPage } from "./pages/AssessmentsManagerPage/AssessmentsManagerPage";
import { ReadingAssessmentBuilderPage } from "./pages/AssessmentBuilders/ReadingAssessmentBuilderPage";
import { ListeningAssessmentBuilderPage } from "./pages/AssessmentBuilders/ListeningAssessmentBuilderPage";
import { TestCompletedPage } from "./pages/TestCompletedPage/TestCompletedPage";
import { SuperAdminRoute } from "./components/SuperAdminRoute";
import { SubmissionsDashboardPage } from "./pages/SubmissionsDashboardPage/SubmissionsDashboardPage";
import { CreateBenchmarkPage } from "./pages/Benchmarks/CreateBenchmarkPage";
import { BenchmarksDashboardPage } from "./pages/Benchmarks/BenchmarksDashboardPage";
import { AssessmentAdminLayout } from "./components/AssessmentAdminLayout";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/reading" element={<Welcome testName="reading" />} />
        <Route
          path="/reading/demo/*"
          element={<ReadingAssessment isDemo={true} />}
        />
        <Route path="/reading/*" element={<ReadingAssessment />} />
        <Route path="/listening" element={<Welcome testName="listening" />} />
        <Route
          path="/listening/demo/*"
          element={<ListeningAssessment isDemo={true} />}
        />
        <Route path="/listening/*" element={<ListeningAssessment />} />
        <Route path="/assessment-completed" element={<TestCompletedPage />} />
        <Route
          path="/assessments-admin"
          element={<Navigate to="/assessments-admin/benchmarks" replace />}
        />
        <Route
          path="/assessments-admin/benchmarks/create"
          element={
            <SuperAdminRoute>
              <AssessmentAdminLayout>
                <CreateBenchmarkPage />
              </AssessmentAdminLayout>
            </SuperAdminRoute>
          }
        />
        <Route
          path="/assessments-admin/benchmarks/:benchmarkId/edit"
          element={
            <SuperAdminRoute>
              <AssessmentAdminLayout>
                <CreateBenchmarkPage />
              </AssessmentAdminLayout>
            </SuperAdminRoute>
          }
        />
        <Route
          path="/assessments-admin/benchmarks"
          element={
            <SuperAdminRoute>
              <AssessmentAdminLayout>
                <BenchmarksDashboardPage />
              </AssessmentAdminLayout>
            </SuperAdminRoute>
          }
        />
        <Route
          path="/assessments-admin/benchmarks/manage"
          element={
            <SuperAdminRoute>
              <AssessmentAdminLayout>
                <AssessmentsManagerPage />
              </AssessmentAdminLayout>
            </SuperAdminRoute>
          }
        />
        <Route
          path="/assessments-admin/submissions"
          element={
            <SuperAdminRoute>
              <AssessmentAdminLayout>
                <SubmissionsDashboardPage />
              </AssessmentAdminLayout>
            </SuperAdminRoute>
          }
        />
        <Route
          path="/assessments-admin/reading-builder"
          element={
            <SuperAdminRoute>
              <AssessmentAdminLayout>
                <ReadingAssessmentBuilderPage />
              </AssessmentAdminLayout>
            </SuperAdminRoute>
          }
        />
        <Route
          path="/assessments-admin/listening-builder"
          element={
            <SuperAdminRoute>
              <AssessmentAdminLayout>
                <ListeningAssessmentBuilderPage />
              </AssessmentAdminLayout>
            </SuperAdminRoute>
          }
        />
        <Route path="*" element={<Navigate to="/reading" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
